import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_SUPPLIERS,
  DELETE_SUPPLIER,
  EDIT_SUPPLIER,
  SAVE_SUPPLIER_PROFILE,
  GET_SUPPLIER_PROFILE,
  GET_FILE_REQUIREMENT_SUPPLIER,
  EXPORT_SUPPLIER
} from "./actionTypes"

import {
  getSuppliersSuccess,
  getSuppliersFail,
  deleteSupplierSuccess,
  deleteSupplierFail,
  editSupplierSuccess,
  editSupplierFail,
  saveSupplierProfileSuccess,
  saveSupplierProfileFail,
  getFileRequirementSuccess,
  getFileRequirementFail,
  exportSupplierSuccess,
  exportSupplierFail
} from "./actions"
import serviceSupplier from "../../api/supplier.service"

function* fetchSuppliers({ payload: filter }) {
  try {
    const response = yield serviceSupplier.getSuppliers(filter).then(r => {
      return r.data !== undefined ? r.data : r.response.data
    })
    yield put(getSuppliersSuccess(response))
  } catch (error) {
    yield put(getSuppliersFail(error))
  }
}
function* onDeleteSupplier({ payload: { supplier, status } }) {
  try {
    const response = yield call(
      serviceSupplier.deleteSuppliers,
      supplier,
      status
    )

    const error = response?.response?.data?.error
    if (error) {
      yield put(deleteSupplierFail(error))
    } else {
      yield put(deleteSupplierSuccess(response))
    }
  } catch (error) {
    yield put(deleteSupplierFail(error))
  }
}
function* onEditSupplier({ payload: supplier }) {
  try {
    const response = yield call(serviceSupplier.editSupplier, supplier)
    yield put(editSupplierSuccess(response))
  } catch (error) {
    yield put(editSupplierFail(error))
  }
}

function* saveSupplierProfile({ payload: data }) {
  try {
    const response = yield call(serviceSupplier.saveSupplierProfile, data)
    yield put(saveSupplierProfileSuccess(response))
  } catch (error) {
    yield put(saveSupplierProfileFail(error))
  }
}

function* getSupplierProfile({ payload: data }) {
  try {
    const response = yield call(serviceSupplier.getSupplierProfile, data)
    yield put(saveSupplierProfileSuccess(response))
  } catch (error) {
    yield put(saveSupplierProfileFail(error))
  }
}

function* getFileRequirement({ payload: idSupplier }) {
  try {
    const response = yield call(serviceSupplier.getFileRequirement, idSupplier)
    yield put(getFileRequirementSuccess(response))
  } catch (error) {
    yield put(getFileRequirementFail(error))
  }
}

function* exportSupplier({payload: idSupplier}) {
  try {
    const response = yield call(serviceSupplier.exportSupplier, idSupplier)
    yield put(exportSupplierSuccess(response))
  } catch (error) {
    yield put(exportSupplierFail(error))
  }
}

function* suppliersSaga() {
  yield takeEvery(GET_SUPPLIERS, fetchSuppliers)
  yield takeEvery(DELETE_SUPPLIER, onDeleteSupplier)
  yield takeEvery(EDIT_SUPPLIER, onEditSupplier)
  yield takeEvery(SAVE_SUPPLIER_PROFILE, saveSupplierProfile)
  yield takeEvery(GET_SUPPLIER_PROFILE, getSupplierProfile)
  yield takeEvery(GET_FILE_REQUIREMENT_SUPPLIER, getFileRequirement)
  yield takeEvery(EXPORT_SUPPLIER, exportSupplier)
}

export default suppliersSaga
